// extracted by mini-css-extract-plugin
export default {"root":"ShippingAddress_root__CDQVa","shippingAddressList":"ShippingAddress_shippingAddressList__scpVg","locationIconContainer":"ShippingAddress_locationIconContainer__svcSV"};